import { byWindowAction, isElementOnScreen } from '@html/_common/utils';

const CLASS_MENU_STICKY = 'ao-clp-menu__wrapper--sticky';
const CLASS_MENU_ITEM_ACTIVE = 'ao-clp-menu__menu-item--active';
const CLASS_MENU_ITEM_ACTIVE_JS = 'js-ao-clp-menu__menu-item--active';

export default function AOClpMenuBar() {
  let $menu = null;
  let $menuSection = null;
  let menuOffset = null;
  let $window = null;
  let $menuItems = null;
  let scrollBuffer = 0;

  const assignActiveClassToElement = ($newActiveElement) => {
    if ($newActiveElement && $newActiveElement.length > 0) {
      $menu.find(`.${CLASS_MENU_ITEM_ACTIVE_JS}`).toggleClass(`${CLASS_MENU_ITEM_ACTIVE} ${CLASS_MENU_ITEM_ACTIVE_JS}`, false);
      $newActiveElement.toggleClass(`${CLASS_MENU_ITEM_ACTIVE} ${CLASS_MENU_ITEM_ACTIVE_JS}`, true);
    }
  };

  const onClick = (event) => {
    const $clickedElement = $(event.currentTarget);
    assignActiveClassToElement($clickedElement);
    scrollBuffer = 50;
  };

  const onScroll = () => {
    // add/remove sticky class
    if (menuOffset <= $window.scrollTop() && !$menu.hasClass(CLASS_MENU_STICKY)) {
      const menuHeight = $menu.height();

      $menu.toggleClass(CLASS_MENU_STICKY, true);
      $menuSection.css('height', `${menuHeight}px`);
    } else if (menuOffset > $window.scrollTop() && $menu.hasClass(CLASS_MENU_STICKY)) {
      $menu.toggleClass(CLASS_MENU_STICKY, false);
      $menuSection.css('height', '');
    }

    const shouldPersistHighlightFromClickEvent = scrollBuffer > 0;
    if (shouldPersistHighlightFromClickEvent) {
      scrollBuffer -= 1;
      return;
    }

    // add/remove active class
    let $activeMenuElement = null;
    $menuItems.toArray().some((element) => {
      const $element = $(element);
      const id = $element.find('a').attr('href');

      const idIsAUrl = id[0] !== '#';
      if (idIsAUrl) {
        return false;
      }

      const $block = $(id);

      if ($block.length > 0 && isElementOnScreen($block)) {
        $activeMenuElement = $element;

        return true;
      }

      return false;
    });

    assignActiveClassToElement($activeMenuElement);
  };

  const initiate = () => {
    $menu = $('.js-ao-clp-menu__wrapper');

    if ($menu.length > 0) {
      $menuSection = $menu.parent();
      menuOffset = $menu.offset().top;
      $window = $(window);
      $menuItems = $('.js-ao-clp-menu__menu-item');

      onScroll();
      byWindowAction(['scroll'], onScroll);
      $menuItems.on('click', onClick);
    }
  };

  return { initiate };
}
